import useDepartmentCreateRouteConfig from "../../../routes/configs/departments/DepartmentCreateRouteConfig";
import useDepartmentEditRouteConfig from "../../../routes/configs/departments/DepartmentEditRouteConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function DepartmentsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("departments");

  //Set the datatable fetch info
  config.setFetchRequest("departments");
  config.setFetchParams({ with_department_parent_data: true });

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //Set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("parent.name"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("department", useDepartmentEditRouteConfig()),
    useDeleteRowActionConfig("department"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("department", useDepartmentCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default DepartmentsDataTable;
